class LocalStorageWatcher {
    constructor(key, callback) {
        this.key = key;
        this.callback = callback;

        this.originalSetItem = localStorage.setItem;
        this.overrideLocalStorage();
    }

    overrideLocalStorage() {
        const self = this;
        localStorage.setItem = function (key, value) {
            self.originalSetItem.call(localStorage, key, value);
            if (key === self.key) {
                self.callback(value);
            }
        };
    }
}

class CartPromotions extends HTMLElement {
    constructor() {
        super();
        this.progressBar = this.querySelector(".progress-bar-inner");
        this.progressMessage = this.querySelector(".progress-message");
        this.placeholder = this.querySelector(".promotions-placeholder");
        this.noch = this.dataset.noch;
        this.biszum = this.dataset.biszum;
        this.success = this.getAttribute("data-success");
        this.paddingPercent = 15;
    }
    connectedCallback() {
        this.init();
        this.waitForDiscount();
    }

    init() {
        this.populatePromotionMarkers();
    }

    async waitForDiscount() {
        return new Promise((resolve) => {
            const discountKey = "discount_code";
            const checkDiscount = () => {
                const discountApplied = localStorage.getItem(discountKey);
                resolve(!!discountApplied);

                  document.addEventListener("ajaxProduct:added", () => {
                    this.fetchAndUpdateCartData(true);
                  });
                  document.addEventListener("ajaxProduct:removed", () => {
                      this.fetchAndUpdateCartData(false);
                  });
                  
                  this.fetchAndUpdateCartData(false); 
                
            };

            checkDiscount();

            new LocalStorageWatcher(discountKey, () => checkDiscount());
        });
    }

    async fetchAndUpdateCartData() {
           try {
   
                const response = await fetch('/cart.js');
                const cartData = await response.json();
                
                
                
                const currentHasDiscounts = cartData.total_discount > 0 || 
                                        cartData.items.some(item => item.original_price > item.price);

                if (currentHasDiscounts) {
                    window.cartData = cartData;
                    console.log(window.cartData, "fetchAndUpdateCartData - immediate update");
                    this.updateCartCounter();
                    return;
                }
                

                console.log('Waiting for discounts to apply...');
                const timeout = 3000;
                const interval = 300;
                let attempts = 1; 
                const maxAttempts = Math.floor(timeout / interval);
                
                const intervalId = setInterval(async () => {
                    attempts++;
                    
                    try {
                        const response = await fetch('/cart.js?t=' + Date.now());
                        const updatedCartData = await response.json();
                        
                        const hasDiscounts = updatedCartData.total_discount > 0 || 
                                        updatedCartData.items.some(item => item.original_price > item.price);
                        
                        console.log(`Attempt ${attempts}: Checking for discounts:`, hasDiscounts);
                        
                        if (hasDiscounts || attempts >= maxAttempts) {
                            clearInterval(intervalId);
                            
                            window.cartData = updatedCartData;
                            console.log(window.cartData, hasDiscounts ? "cart data with discount" : "cart data after timeout");
                            this.updateCartCounter();
                        }
                        
                    } catch (error) {
                        console.error('Error fetching cart:', error);
                        clearInterval(intervalId);
                    }
                }, interval);
                
            } catch (err) {
                console.error('Error loading /cart.js:', err);
            }
    }

    async updateCartCounter() {
        const cartData = window.cartData;
        const totalPrice = cartData ? cartData.total_price / 100 : 0;
        console.log(totalPrice, "total Pr")
        this.updateProgressBar(totalPrice);
        for (let promotion of promotionsData) {
            if (totalPrice < promotion.threshold && promotion.product !== 0) {
                if (await this.productInCart(promotion.product)) {
                    await this.removePromotionProductFromCart(promotion.product)
                }
            }
        }
    }

    async productInCart(productId) {
        const cartData = window.cartData;
        return cartData.items.some((item => item.id === productId))
    }
    async updateProgressBar(cartTotalPrice) {
        console.log('updateProgressBar cartTotalPrice', cartTotalPrice)
        const promotions = promotionsData.slice();
        let progressPercentage = 0;
        let currentSegmentIndex = promotions.findIndex((promo => cartTotalPrice < promo.threshold));
        if (currentSegmentIndex === -1) {
            progressPercentage = 95;
            this.progressMessage.textContent = this.success;
            console.log("All promotions are met")
        } else {
            const segmentWidth = 100 / (promotions.length + 1);
            const previousThreshold = currentSegmentIndex === 0 ? 0 : promotions[currentSegmentIndex - 1].threshold;
            const currentThreshold = promotions[currentSegmentIndex].threshold;
            const segmentProgress = (cartTotalPrice - previousThreshold) / (currentThreshold - previousThreshold);
            progressPercentage = currentSegmentIndex * segmentWidth + segmentProgress * segmentWidth;
            let difference = currentThreshold - cartTotalPrice;
            const promotionName = promotions[currentSegmentIndex].name_secondary || promotions[currentSegmentIndex].name;
            this.progressMessage.innerHTML = `${this.noch} <strong>${window.currency_code}${difference.toFixed(2)}</strong> ${this.biszum} ${promotionName}!`;
            if (cartTotalPrice >= previousThreshold && promotions[currentSegmentIndex].optional_text) {
                this.progressMessage.innerHTML += `<div>${promotions[currentSegmentIndex].optional_text}</div>`
            }
        }
        this.progressBar.style.width = `${progressPercentage}%`;
        promotions.forEach(((promotion, index) => {
            const image = this.placeholder.querySelector(`[data-label="${promotion.name}"]`);
            if (image) {
                image.classList.toggle("inactive", cartTotalPrice < promotion.threshold)
            }
        }))
    }
    addPromotionProductToCart(productId, promoTag) {
        if (document.querySelector('quiz-container')) {
            return;
        }
        const data = {
            id: productId,
            quantity: 1,
            properties: {
                __free_product: "true"
            }
        };
        if (promoTag) {
            data.properties.__promoTag = promoTag
        }
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then((response => response.json())).then((data => {
            console.log("Success:", data);
            console.log("Promotion product is added");
            document.dispatchEvent(new CustomEvent("ajaxProduct:added"))
        })).catch((error => {
            console.error("Error:", error)
        }))
    }
    getMaxThreshold() {
        return Math.max(...promotionsData.map((promotion => promotion.threshold)))
    }
    async removePromotionProductFromCart(productId) {
        const cartData = window.cartData;
        const lineItem = cartData.items.find((item => item.product_id === productId && item.properties?.__promoTag));
        if (lineItem) {
            await fetch(`/cart/change.js`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: lineItem.key,
                    quantity: 0
                })
            })
            document.dispatchEvent(new CustomEvent("ajaxProduct:removed"));
        }
    }
    populatePromotionMarkers() {
        const numPromotions = promotionsData.length;
        const paddingPercent = 15;
        const markerWidth = 46;
        for (let i = 0; i < numPromotions; i++) {
            let promotion = promotionsData[i];
            let percentage;
            let leftPosition;
            let label_left_space;
            if (numPromotions === 2) {
                percentage = 33.33 + i * 33.33
            } else {
                percentage = paddingPercent + (100 - paddingPercent * 2) * i / (numPromotions - 1)
            }
            if (numPromotions === 1) {
                leftPosition = `calc(50% - ${markerWidth / 2}px)`;
                label_left_space = `calc(50% - ${markerWidth / 2 + 8}px)`
            } else {
                percentage = numPromotions === 2 ? 33.33 + i * 33.33 : this.paddingPercent + (100 - this.paddingPercent * 2) * i / (numPromotions - 1);
                leftPosition = `calc(${percentage}% - ${markerWidth / 2}px)`;
                if (promotion.name.length > 22) {
                    label_left_space = `calc(${percentage}% - ${markerWidth / 2 + 8}px)`
                } else {
                    label_left_space = leftPosition
                }
            }
            let marker = document.createElement("div");
            marker.className = "promotion-marker";
            marker.innerHTML = promotion.image ? `<img data-label="${promotion.name}" class="promotion-image inactive" width="46" height="46" fetchpriority="low" loading="lazy" src="${promotion.image}" alt="${promotion.image.alt ? promotion.image : 'Promotion image'}" />` : "";
            marker.style.left = leftPosition;
            this.placeholder.appendChild(marker);
            let label = document.createElement("div");
            label.className = "promotion-label";
            label.innerHTML = promotion.name;
            label.style.left = label_left_space;
            this.placeholder.appendChild(label);
            let price = document.createElement("div");
            price.className = "promotion-price";
            price.innerHTML = promotion.price;
            price.style.left = leftPosition;
            this.placeholder.appendChild(price)
        }
    }
    async getNearestPromotion(currentAmount) {
        var nearestPromotion = null;
        for (let promotion of promotionsData) {
            if (currentAmount < promotion.threshold) {
                if (!nearestPromotion || promotion.threshold < nearestPromotion.threshold) {
                    nearestPromotion = promotion
                }
            } else {
                if (promotion.product !== 0 && !await this.productInCart(promotion.product)) {
                    return promotion
                }
            }
        }
        return nearestPromotion
    }
}
customElements.define("cart-promotions", CartPromotions);